import type { FieldProps } from '@eliadmin/core/src/components/configurator/configurator-field';
import { useConfiguratorField } from '@eliadmin/core/src/components/configurator/configurator-field';
import { ConfiguratorFieldLabel } from '@eliadmin/core/src/components/configurator/configurator-field-label';
import { Switch } from '@eliadmin/core/src/components/ui/switch';
import { useErrSync } from '@eliadmin/core/src/stores/configurator-store';

export function ConfigurationSwitch({ fieldConfig }: FieldProps<'switch'>) {
  const { value, onChange } = useConfiguratorField(fieldConfig);

  const isInvalid = !value && fieldConfig.must === '1';
  useErrSync(fieldConfig.column, isInvalid);
  const isOn = value === '1';

  return (
    <div className="flex w-full flex-col gap-1">
      <ConfiguratorFieldLabel fieldConfig={fieldConfig} isInvalid={isInvalid} />
      <Switch
        id={fieldConfig.column}
        checked={isOn}
        classNames={{
          wrapper:
            'h-7 w-12 border-2 border-muted-foreground/80 shadow-inner transition-all duration-200 focus-visible:ring-accent data-[state=checked]:border-accent data-[state=checked]:bg-accent data-[state=unchecked]:bg-muted-foreground/30',
          thumb:
            'h-5 w-5 border border-black/10 bg-white shadow-[0_2px_5px_rgba(0,0,0,0.28)] transition-transform duration-200 data-[state=checked]:translate-x-6 data-[state=unchecked]:translate-x-0',
        }}
        onCheckedChange={checked => {
          onChange(checked ? '1' : '0');
        }}
      />
    </div>
  );
}
